"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOptions = exports.sortByOptions = exports.rowsPerPageOptions = exports.columns = void 0;
var columns = [
    { uid: "expand", name: "" },
    { uid: "tariffName", name: "TARIFF NAME" },
    { uid: "period", name: "PERIOD" },
    { uid: "transmissionZone", name: "ZONE" },
    { uid: "voltageLevel", name: "VOLTAGE" },
    { uid: "effectiveFrom", name: "EFFECTIVE FROM" },
    { uid: "effectiveTo", name: "EFFECTIVE TO" },
    { uid: "status", name: "STATUS" },
    { uid: "actions", name: "ACTIONS" },
];
exports.columns = columns;
var statusOptions = [
    { key: "all", label: "All Statuses" },
    { key: "active", label: "Active" },
    { key: "inactive", label: "Inactive" },
];
exports.statusOptions = statusOptions;
var sortByOptions = [
    { key: "effectiveFrom", label: "Effective From" },
    { key: "tariffName", label: "Tariff Name" },
    { key: "effectiveTo", label: "Effective To" },
];
exports.sortByOptions = sortByOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
